import React from 'react';
import './award.scss';
import { useMediaQuery } from 'react-responsive';
import '../../components/About/about.scss';

const awards = [
    {
        id: 1,
        imgSrc: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1738405550/WhatsApp_Image_2025-01-24_at_18.58.45_rr3dyo.jpg',
        title: 'NICCEA 7TH EDITION AWARD, 2024',
        description: 'Nigeria Canadian Celebrities Entertainment Award Of Excellence.'
    },
    {
        id: 2,
        imgSrc: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1738405549/WhatsApp_Image_2025-01-24_at_18.59.11_gpkyix.jpg',
        title: 'FOYA AWARDS, 2025',
        description: 'Outstanding contributions to the entertainment industry.'
    },
    {
        id: 3,
        imgSrc: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1738405549/WhatsApp_Image_2025-01-24_at_18.58.56_uucif1.jpg',
        title: 'ESTEEM AWARD, 2024',
        description: 'Outstanding performance and successful achievements.'
    },
    {
        id: 4,
        imgSrc: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1740772350/Screenshot_2025-02-28_205127_wzaaft.png',
        title: 'CANADIAN CHOICE AWARD, 2024',
        description: 'Winner in Entertainment services - North york.'
    },
];

const AwardsGallery = () => {

    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });


    return (
        <section className="award__section" style={{ display: 'flex', flexDirection: 'column', gap: isMediumScreen ? '50px' : '100px', marginTop: isMediumScreen ? '50px' : '100px'  }}>
            <div className="award__section1" style={{ display: 'flex', flexDirection: isMediumScreen ? 'column' : 'row', gap: '50px', justifyContent: 'space-between', }}>
                <div className="second__section1" style={{ flexBasis: '50%', flex: 1, display: 'flex', flexWrap: 'nowrap', gap: '8px', justifyContent: 'start', alignItems: 'start' }}>
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859' }}></div>
                    <p style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, color: '#916859' }}>AWARDS</p>
                </div>
                <div className="second__section2" style={{ flexBasis: '50%', flex: 1 }}>
                    <p style={{ fontSize: isMediumScreen ? '36px' : '50px', lineHeight: isMediumScreen ? '44px' : '60px', fontWeight: 500, marginBottom: '50px', color: '#916859' }}>
                        Meet <span style={{ fontStyle: 'italic' }}>the face & brains</span> behind Dudu&apos;s World of Entertainment.
                    </p>
                    <p style={{ fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '35px', color: '#916859', marginBottom: '30px' }}>
                        As a Nigerian-born event planner in Canada, Modupe Sonayon has carved a niche for herself in the bustling events industry of Canada. Her journey
                        from Nigeria to Canada has been marked by resilience, determination, shaping her into the visionary CEO behind Dudu&apos;s World of Entertainment.
                        Her venture into event planning began over two decades ago, ignited by her love for the world of entertainment nurtured since her high school days.
                        As she navigates the intricacies of balancing work, education, and motherhood, Modupe Sonayon has established herself not only as a pioneer in the
                        field but also as a testament to resilience, dedication, and unwavering passion.
                    </p>
                </div>
            </div>
            <div className="awards-gallery">
                {awards.map((award) => (
                    <div key={award.id} className="award-card">
                        <img
                            src={award.imgSrc}
                            alt={award.title}
                            className="award-image"
                        />
                        <div className="award-details">
                            <h3>{award.title}</h3>
                            <p>{award.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default AwardsGallery;
